<template>
  <div>
    <VueSignaturePad
      id="signature"
      ref="signature"
    />
    <div class="buttons-wrapper">
      <el-button
        type="primary"
        @click="saveUserSignature"
      >
        {{ $t('common.buttons.done') }}
      </el-button>
      <el-button
        type="back"
        @click="clear"
      >
        {{ $t('common.buttons.clear') }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Signature',
  props: {
    signature: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    base64: ''
  }),
  watch: {
    base64: function (value) {
      this.$emit('update:signature', value);
    }
  },
  methods: {
    clear () {
      this.$refs.signature.clearSignature();
    },
    saveUserSignature () {
      const { isEmpty, data } = this.$refs.signature.saveSignature();
      if (!isEmpty) {
        this.base64 = data;
      } else {
        this.setMessage(this.$t('common.errors.signature'), 'warning');
      }
    }
  }
};
</script>

